export const SCHEMA_VERSION = '1.10.0';
